<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="localization-configuration"
    [viewName]="title"
    [record]="localizationConfigRecord"
    [fields]="fields"
>
</dynamic-view-v2>
